import React, { Component } from 'react';
import querystring from 'querystring';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Pagination from 'rc-pagination';
import USLocale from 'rc-pagination/lib/locale/en_US';
import 'rc-pagination/assets/index.css';
import Icon from '../common/icons/Icon';
import SwingSubmittalsPendingReviewCount from './SwingSubmittalsPendingReviewCount';

class SwingSubmittalsListPage extends Component {
  setPage = page => {
    const qs = this.props.location.search ? querystring.parse(this.props.location.search.slice(1)) : {};

    this.setQuerystring(Object.assign(qs, { page }));
  };

  toggleView = viewHistory => () => {
    if (viewHistory) {
      this.setQuerystring({});
    } else {
      this.setQuerystring({ page: 1, viewHistory: true });
    }
  };

  setQuerystring = qs => {
    this.props.history.push(`${this.props.match.path}?${querystring.stringify(qs)}`);
  };

  renderPendingSubmittals = () => {
    const { pendingReview, location } = this.props;
    return (
      <ul className="admin-paper__list">
        {pendingReview.get('data').size ? (
          pendingReview.get('data').map(swing => (
            <li key={`swing-${swing.get('id')}`}>
              <div className="admin-paper__list__title">
                {`${swing.getIn(['submittedBy', 'name'])} (${swing.getIn(['type', 'short_name'])}) - ${moment(
                  swing.get('updated_at')
                ).format('M/D/YY')}`}
              </div>
              <Link className="admin-paper__list__link" to={`/swing-submittals/${swing.get('id')}${location.search}`}>
                Go to Swing <Icon icon="Arrow" />
              </Link>
            </li>
          ))
        ) : (
          <div className="admin-paper__no-content">There are no Swing Submittals pending review</div>
        )}
      </ul>
    );
  };

  renderHistory = () => {
    const { submittalsHistory, location } = this.props;
    return (
      <ul className="admin-paper__list">
        {submittalsHistory.getIn(['data', 'results']).size ? (
          submittalsHistory.getIn(['data', 'results']).map(swing => (
            <li key={`swing-${swing.get('id')}`}>
              <div className="admin-paper__list__title">
                {`${swing.getIn(['submittedBy', 'name'])} (${swing.getIn(['type', 'short_name'])}) - ${moment(
                  swing.get('updated_at')
                ).format('M/D/YY')} - Reviewed by ${swing.getIn(['respondedBy', 'name'])}`}
              </div>
              <Link className="admin-paper__list__link" to={`/swing-submittals/${swing.get('id')}${location.search}`}>
                Go to Swing <Icon icon="Arrow" />
              </Link>
            </li>
          ))
        ) : (
          <div className="admin-paper__no-content">There are no completed Swing Submittals</div>
        )}
      </ul>
    );
  };

  render() {
    const { pendingReviewCount, location: { search }, submittalsHistory } = this.props;
    const qs = search ? querystring.parse(search.slice(1)) : {};

    return (
      <div className="swing-submittals--page">
        <div className="admin-paper">
          <div className="admin-paper__header">
            <h3>
              Swing Submittals <SwingSubmittalsPendingReviewCount count={pendingReviewCount.getIn(['data', 'count'])} />
            </h3>
            <button className="button button--theme--outline" type="button" onClick={this.toggleView(qs.viewHistory)}>
              {qs.viewHistory ? 'View Active' : 'View History'}
            </button>
          </div>
          {qs.viewHistory ? this.renderHistory() : this.renderPendingSubmittals()}
        </div>
        {qs.viewHistory && (
          <div className="admin-pagination__wrapper">
            {submittalsHistory.getIn(['data', 'pagination', 'rowCount']) >
              submittalsHistory.getIn(['data', 'pagination', 'pageSize']) && (
              <Pagination
                onChange={this.setPage}
                current={parseInt(qs.page || 1, 10)}
                pageSize={submittalsHistory.getIn(['data', 'pagination', 'pageSize'])}
                total={submittalsHistory.getIn(['data', 'pagination', 'rowCount'])}
                locale={USLocale}
              />
            )}
          </div>
        )}
      </div>
    );
  }
}

export default connect(state => {
  return {
    submittalsHistory: state.swingSubmittals.history,
    pendingReview: state.swingSubmittals.pendingReview,
    pendingReviewCount: state.swingSubmittals.pendingReviewCount,
  };
})(SwingSubmittalsListPage);



// WEBPACK FOOTER //
// ./src/swing-submittals/SwingSubmittalsListPage.js